import { datadogRum } from '@datadog/browser-rum';
import { init as initFullStory } from '@fullstory/browser';
import ReactDOM from 'react-dom/client';

import { App } from './app';

initFullStory({ orgId: '8HR7J', devMode: process.env.NODE_ENV === 'development' });

datadogRum.init({
    applicationId: '7507aba7-695f-427f-9077-c996ab6b7410',
    clientToken: 'pub1cab0c444505f0909517fc31c7892f13',
    site: 'datadoghq.com',
    service: 'customer-portal-2',
    env: window.location.hostname,
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask-user-input',
    trackUserInteractions: true,
    trackResources: true,
});

const appContainer = document.createElement('div');
document.body.appendChild(appContainer);
const rootContainer = ReactDOM.createRoot(appContainer);

rootContainer.render(<App />);
